export default __webpack_public_path__ + "static/media/gallery-wip-denix-barrel_01.e37a25e5.jpg";